/**
 * Producer stays at the bottom (index 1). Upper 1 is the first upline row
 * above the producer, then Upper 2, and so on. The stored array stays
 * highest-index first, which is the order commission walks from the end.
 * Only index and level labels change. Row order, percentages, and level
 * types stay as they are, so who is paid does not change.
 */
export const renumberOverridingRows = (rows) => {
  const source = Array.isArray(rows) ? rows : [];
  const ordered = [...source].sort(
    (a, b) => Number(a?.index) - Number(b?.index)
  );
  let upper = 0;
  const numbered = ordered.map((row, position) => {
    const next = { ...row, index: position + 1 };
    if (Number(row?.level) === 0) {
      next.level = 0;
      return next;
    }
    const levelType =
      row?.levelType === "topUpline" || Number(row?.level) === -3
        ? "topUpline"
        : row?.levelType;
    if (levelType === "topUpline") next.levelType = "topUpline";
    switch (levelType) {
      case "topUpline":
        next.level = -3;
        break;
      case "userGroup":
        next.level = -1;
        break;
      case "user":
        next.level = -2;
        break;
      default:
        upper += 1;
        next.level = upper;
        if (!levelType) next.levelType = "upper";
        break;
    }
    return next;
  });
  return numbered.sort((a, b) => b.index - a.index);
};

export const overridingNumberingKey = (rows) =>
  (Array.isArray(rows) ? rows : [])
    .map((row) => `${row?.index}:${row?.level}:${row?.levelType || ""}`)
    .join("|");
